import styled from 'styled-components';

const Nav = styled.nav`
  margin: 0;
`;

export default Nav;
